// Describes a submission's timeliness by comparing when it was turned in
// against the resource's due date. Returns null when not applicable —
// nothing submitted, or no due date to judge against.
export interface Lateness {
  late: boolean;
  label: string; // "on time" | "late" | "Nd late"
}

export const submissionLateness = (
  submittedAt: string | null,
  dueDate: string | null
): Lateness | null => {
  if (!submittedAt || !dueDate) return null;
  const sub = new Date(submittedAt).getTime();
  const due = new Date(dueDate).getTime();
  if (Number.isNaN(sub) || Number.isNaN(due)) return null;
  if (sub <= due) return { late: false, label: "on time" };
  const days = Math.floor((sub - due) / 86_400_000);
  return { late: true, label: days >= 1 ? `${days}d late` : "late" };
};
